var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"cancel-button md:md-cancel-button",on:{"click":function($event){return _vm.reset()}}},[_vm._v(" Exit Game ")])])}
var staticRenderFns = []

export { render, staticRenderFns }